import axios from 'axios'
import moment from 'moment-timezone'
import lodash from 'lodash';
import deepdash from 'deepdash-es';
const _ = deepdash(lodash);
moment.tz.setDefault('Asia/Tokyo');

export default {
  getPlans: (token, lang) => {
    return new Promise((resolve, reject) => {
      axios.get('plan', { params: { token: token, language: lang }})
        .then(payload => {
          let plans = []
          if (payload.data.success) {
            const planList = payload.data.plans
            const today = moment();

            let beforePlans = [];
            let afterPlans = [];

            // マイプラン(予定)
            for (let i = 0; i < planList.length; i++) {
              const d = moment(planList[i].date)
              if (d.isSameOrAfter(today, 'day')) {
                beforePlans.push({
                  id: planList[i].id,
                  date: moment(planList[i].date),
                  title: planList[i].title,
                  expired: false
                });
              }
            }

            beforePlans.sort(function(a, b) {
              return (a.date < b.date ? -1 : 1);
            });
            plans.push(...beforePlans);

            // マイプラン(過去)
            for (let i = 0; i < planList.length; i++) {
              const d = moment(planList[i].date)
              if (d.isBefore(today, 'day')) {
                afterPlans.push({
                  id: planList[i].id,
                  date: moment(planList[i].date),
                  title: planList[i].title,
                  expired: true
                });
              }
            }

            afterPlans.sort(function(a, b) {
              return (a.date > b.date ? -1 : 1);
            });
            plans.push(...afterPlans);
            resolve(plans)
          } else {
            reject()
          }
        })
    })
  },
  savePlan: (params) => {
    return new Promise((resolve, reject) => {
      axios.put('plan', params)
        .then(payload => {
          resolve(payload.data.id)
        })
        .catch(() => {
          reject()
        })
    })
  },
  getPlan: (params) => {
    return new Promise((resolve, reject) => {
      axios.get('plan', { params: params })
        .then(payload => {
          const p = payload.data.plan
          let plan = {
            items: {
              ...p.items,
              condition: parseCondition(p.items.condition),
              routes: parseRoutes(p.items.routes),
              stations: p.items.stations
            },
            title: p.title,
            editable: p.editable,
            datetime: moment(p.datetime)
          }
          resolve(plan)
        })
        .catch(() => {
          reject()
        })
    })
  },
  deletePlan: (params) => {
    return new Promise((resolve) => {
      axios.delete('plan', { params: params })
        .then(() => {
          resolve()
        })
    })
  }
}

function parseCondition(condition) {
  return {
    ...condition,
    time: moment(condition.time)
  }
}

function parseRoutes(routes) {
  _.eachDeep(routes, (v) => {
    if (_.has(v, 'arrivalTime')) {
      v['arrivalTime'] = moment(v['arrivalTime'])
    }
    if (_.has(v, 'departureTime')) {
      v['departureTime'] = moment(v['departureTime'])
    }
  });

  return routes
}
